import { render, staticRenderFns } from "./ViewLoader.vue?vue&type=template&id=7e128a7d"
import script from "./ViewLoader.vue?vue&type=script&lang=js"
export * from "./ViewLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports